/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S1_HeadingInputs */

const tr_iade_iptal_s1_heading = /** @type {(inputs: Iade_Iptal_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Kapsam ve Amaç`)
};

const en_iade_iptal_s1_heading = /** @type {(inputs: Iade_Iptal_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Scope and Purpose`)
};

const de_iade_iptal_s1_heading = /** @type {(inputs: Iade_Iptal_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Geltungsbereich und Zweck`)
};

const ru_iade_iptal_s1_heading = /** @type {(inputs: Iade_Iptal_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Сфера применения и цель`)
};

/**
* | output |
* | --- |
* | "1. Scope and Purpose" |
*
* @param {Iade_Iptal_S1_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s1_heading = /** @type {((inputs?: Iade_Iptal_S1_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S1_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s1_heading(inputs)
	if (locale === "de") return de_iade_iptal_s1_heading(inputs)
	if (locale === "ru") return ru_iade_iptal_s1_heading(inputs)
	return tr_iade_iptal_s1_heading(inputs)
});